
<div class="viewport-height flex-column gap-none">

  <ss-mobile-toolbar #mobileToolbar ></ss-mobile-toolbar>
  
  <mat-drawer-container [hasBackdrop]="false" class="flex-1" style="max-height: 100%;">

    <mat-drawer
      id="sidenav-drawer"
      class="padding-none primary-background border-style-none"
      [ngStyle]="{
        width:widthObs | async
      }"
      [mode]="modeSubject | async"
      [opened]="openedSubject | async"
    
    >
      <ss-sidenav-content>
      </ss-sidenav-content>
    </mat-drawer>

    <mat-drawer-content 
      class="position-relative"
      [ngStyle]="{
        'margin-left':marginLeftObs | async,
        width:contentWidthObs | async
      }"
    >
        <div *ngIf="openedSubject | async" class="sidenav-inverted-radius-container primary-background">
          <div class="sidenav-inverted-radius"></div>
        </div>
        <ng-content></ng-content>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
